if (!customElements.get('gift-box-choices')) {
  customElements.define(
    'gift-box-choices',
    class GiftBoxChoices extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;

        this.scope = this.closest('.shopify-section') || document.body;
        this.removeSimpleBundlesControls();
        this.observer = new MutationObserver(() => this.removeSimpleBundlesControls());
        this.observer.observe(this.scope, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      removeSimpleBundlesControls() {
        this.scope.querySelectorAll('#simple-bundles-io-options').forEach((container) => container.remove());
        this.scope
          .querySelectorAll(
            'input[type="hidden"][name^="properties[Product "], input[type="hidden"][name="properties[_bundle_selection]"]'
          )
          .forEach((input) => input.remove());
      }
    }
  );
}
